<template>
  <div class="city-salary-table">

    <div style="margin-bottom: 30px">
      <el-button @click="setProvinceSalary()">使用省份参考价
      </el-button>

      <el-input style="width: 300px; margin-left: 5px" placeholder="请输入价格" v-model="customSalary" class="input-with-select">
        <el-button slot="append" @click="setSalary()">一键修改价格</el-button>
      </el-input>

    </div>

    <el-table :data="cityTable"
              border
              height="800px"
              style="width: 100%"
              :row-class-name="tableRowClassName">
      <el-table-column prop="cityname"
                       label="城市">
        <template slot-scope="scope">{{scope.row.name}}</template>
      </el-table-column>
      <el-table-column prop="task_count"
                       sortable
                       label="任务数">
      </el-table-column>
      <el-table-column prop="city_salary"
                       sortable>
        <template slot="header" slot-scope="scope">
          <el-tooltip content="城市单价以10分钟为计数最小单位"
                      effect="dark">
            <span>城市单价(元) <i class="el-icon-question"></i></span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.city_salary">{{scope.row.city_salary | toFixed(2)}}</div>
          <div v-else>尚未有参考定价</div>
        </template>
      </el-table-column>
      <el-table-column prop="task_time_period"
                       label="做单时长(分钟)">
        <template >{{taskTimeDuration}}</template>
      </el-table-column>
      <el-table-column prop="task_salary"
                       label="任务赏金(元)">
        <template slot-scope="scope">
          <div @click="handleClickRow(scope.row)">
            <div v-if="scope.row.on_editing">
              <el-input :ref="'row-' + scope.row.cityid"
                        size="mini"
                        v-model="scope.row.task_salary"
                        @blur="onBlurChangeSalary(scope.row)">
              </el-input>
            </div>
            <div v-else>{{scope.row.task_salary | toFixed(2)}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="points"
                       label="零豆">
        <template slot-scope="scope">{{calculatePoints(scope.row.task_salary)}}</template>
      </el-table-column>
      <el-table-column prop="city_total">
        <template slot="header" slot-scope="scope">
          <el-tooltip :content="`总计 = 任务赏金 * 任务数 * 需要人数`"
                      effect="dark">
            <span>总计(元) <i class="el-icon-question"></i></span>
          </el-tooltip>
        </template>
        <template slot-scope="scope">{{scope.row.task_salary * scope.row.task_count * hirenum | toFixed(2)}}</template>
      </el-table-column>
    </el-table>
    <div style="display: flex;justify-content: space-between;margin: 0 30px">
      <div style="margin: 10px 0">
        <span style="color: #F56C6C;font-weight: bolder">*</span>任务赏金 = 城市单价 x 做单时长 / 10，为参考价格，项目负责人可直接使用或手动调整。
      </div>
      <div style="margin: 10px 0">
        <span style="display: inline-block;margin-right: 20px">项目可用成本：{{projectRemainAmount}}元</span>
        <span style="display: inline-block">任务费用总计：<b style="color: #F56C6C;font-size: 1.2em">{{totalSalary}}</b>元</span>
      </div>
    </div>
    <div style="display: flex;justify-content: flex-end;margin: 30px 0">
      <el-button @click="onCancelMiddleEndTask">取消</el-button>
      <el-button type="primary" @click="submitMarketTask">提交</el-button>
    </div>
  </div>
</template>

<script>
import {calculatePoints} from '@/views/task/components/task-functions'

export default {
  props: {
    table: {
      type: Array,
      default: []
    },
  },
  inject: ['taskForm'],
  data () {
    return {
      cityTable: [],
      customSalary: '',
      taskCount: 0
    }
  },
  watch: {
    taskTimeDuration () {
      this.reCalculateCityTable()
    },
    table (table) {
      this.cityTable = filter.copyJson(table)
      this.taskCount = 0
      for (let i in this.cityTable) {
        if (this.cityTable.hasOwnProperty(i)) {
          let city = this.cityTable[i]
          let taskCount = this.taskForm.taskAreaType === 2 ? city.markets.length : city.count
          this.taskCount += taskCount
          let salary = _.round(city.city_salary / 10 * this.taskTimeDuration * city.city_order_coefficient, 2)
          this.$set(city, 'on_editing', false)
          if (!city.task_salary) {
            this.$set(city, 'task_salary', salary)
            this.$set(city, 'task_count', taskCount)
            this.$set(city, 'points', this.calculatePoints(salary))
          }
        }
      }
    }
  },
  computed: {
    disableSubmit () {
      for (let i in this.cityTable) {
        if (this.cityTable.hasOwnProperty(i) && this.cityTable[i].task_salary === 0) {
          return true
        }
      }
      return false
    },
    totalSalary () {
      let total = 0
      for (let i in this.cityTable) {
        let city = this.cityTable[i]
        total += city.task_salary * city.task_count * this.hirenum
      }

      return _.round(total, 2)
    },
    hirenum () {
      return this.taskForm.form.hirenum
    },
    taskTimeDuration () {
      return this.taskForm.form.estimate_consume_mins
    },
    projectRemainAmount () {
      return this.taskForm.projectRemainAmount
    },
  },
  methods: {
    calculatePoints,
    submitMarketTask () {
      if (this.disableSubmit) {
        this.$alert('部分城市任务尚未有参考定价，请手动输入任务赏金。', '提示', {type: 'error'})
        return
      }

      this.$alert('当前项目可用成本为：' + this.projectRemainAmount, '提示', {type: 'warning'}).then(() => {
        this.$emit('submitTask', this.cityTable, this.totalSalary, this.taskCount)
      })
    },
    onBlurChangeSalary (row) {
      this.$set(row, 'on_editing', false)
    },
    handleClickRow (row) {
      this.$set(row, 'on_editing', true)
      this.$nextTick(() => {
        this.$refs['row-' + row.cityid].focus()
      })
    },
    onCancelMiddleEndTask () {
      this.$confirm('是否要放弃本次创建任务，并返回任务列表？', '提示', {type: 'warning'}).then(() => {
        this.$router.push('/task/table')
      })
    },
    reCalculateCityTable () {
      for (let i in this.cityTable) {
        if (this.cityTable.hasOwnProperty(i)) {
          let city = this.cityTable[i]
          this.$set(city, 'task_salary', _.round(city.city_salary / 10 * this.taskTimeDuration * city.city_order_coefficient, 2))
        }
      }
    },
    tableRowClassName ({row, rowIndex}) {
      if (parseFloat(row.task_salary) === 0 && parseFloat(row.city_salary) === 0) {
        return 'warning-row'
      } else {
        return ''
      }
    },
    setProvinceSalary () {
      this.$confirm('是否要让尚未有参考定价的城市使用所在省份的平均价？', '提示', {type: 'warning'}).then(() => {
        for (let i in this.cityTable) {
          if (this.cityTable.hasOwnProperty(i) && parseFloat(this.cityTable[i].task_salary) === 0) {
            this.cityTable[i].task_salary = this.cityTable[i].avg_salary / 10 * this.taskTimeDuration
          }
        }
      })
    },
    setSalary () {
      this.$confirm('是否要一键修改所有参考定价？', '提示', {type: 'warning'}).then(() => {
        for (let i in this.cityTable) {
          if (this.cityTable.hasOwnProperty(i)) {
            this.cityTable[i].task_salary = this.customSalary
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
.city-salary-table .el-table .warning-row {
  background: #FEF0F0;
}

</style>



// WEBPACK FOOTER //
// src/views/middle-end-task/components/CitySalaryTable.vue